import React, {useState} from 'react'
import Input from 'components/Input'
import Button from 'components/Button'
import {useFunction} from 'utils/hooks/function'
import services from 'services'
import {UserCredentialType} from 'data/enums'
import {Col, Row} from 'components/Display'
import i18n from 'i18n-js'
import {isValidEmail} from 'utils'
import {usePublished} from 'utils/published'
import config from 'config'
import itxLogo from 'assets/iteration-x-128x128.png'
import extensionLogo from 'assets/extension-logo.svg'

export default function LoginView() {
  const authService = services.getAuthService()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const error = usePublished(authService.error)

  const login = useFunction(authService.login)

  return (
    <Col className="flex-1 w-full sm:bg-gray-itx-light items-center justify-center">
      <Col
        className={`w-full h-full md:h-auto md:w-2/5 lg:w-${config.isChromeExtension ? 'full' : '2/5'} xl:w-${
          config.isChromeExtension ? 'full' : '1/5'
        } md:shadow-2xl bg-white px-4 py-4 rounded`}
      >
        {config.isChromeExtension ? (
          <img className={`w-6/12 pt-2 pb-2`} alt={'extensionLogo'} src={extensionLogo} />
        ) : (
          <Col>
            <Row className="justify-center mt-2">
              <img src={itxLogo} className="w-12 h-12" alt="itx-logo" />
            </Row>
            <Row className="font-extrabold justify-center mt-8 text-xl">{i18n.t('login.title')}</Row>
          </Col>
        )}

        <div className={`${config.isChromeExtension && 'bg-itx-greyscale-1'} pt-2 pb-4 px-8`}>
          <form
            onSubmit={(event) => {
              event.preventDefault()
              login(email, password, UserCredentialType.EMAIL_PASSWORD)
            }}
          >
            <Col className="mt-8">
              {error != null && <Row className="text-red-400 mb-4 justify-center">{error}</Row>}
              <Input
                className="border px-2 py-2 rounded"
                type="email"
                placeholder={i18n.t('login.identifierPlaceholder')}
                value={email}
                onChange={setEmail}
              />
              <Input
                className="border px-2 py-2 mt-2 rounded"
                placeholder={i18n.t('login.passwordPlaceholder')}
                type="password"
                value={password}
                onChange={setPassword}
              />
            </Col>
            <Row className="justify-center w-full mt-8">
              <Button
                disabled={!email || !password || !isValidEmail(email)}
                className={`flex-1 justify-center py ${config.isChromeExtension && 'bg-itx-primary-4 text-white'}`}
                content={i18n.t('login.signInButtonText')}
              />
            </Row>
          </form>
        </div>
      </Col>
    </Col>
  )
}
